import { render, staticRenderFns } from "./OFilesTable.vue?vue&type=template&id=94768a8a&"
import script from "./OFilesTable.vue?vue&type=script&lang=js&"
export * from "./OFilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports